// extracted by mini-css-extract-plugin
export default {"circle":"checkMark_circle__DIkHI","tick":"checkMark_tick__h+CIE"};